import scrollTo from '../helpers/scrollTo';

import { isHomePage } from '../helpers/consts';
export default () => {
	const scrollTopBtn = document.querySelector('.js-footer-scroll-top');
	if(scrollTopBtn) {
		scrollTopBtn.addEventListener('click', () => {
			scrollTo(0, 0, isHomePage ? 2500 : 1500);
		});
	}
}
